import { z } from "zod/v4";

export const noSttSchema = z
.string().check(
  z.refine(val => val.match(/^10LP/gi) || val.match(/^98LP/gi) || val.match(/^19LP/gi), {
    error: "bookingV3.sttManualReference.error.sttManual"
  }),
  z.trim()
);

export const sttReferenceSchema = z
  .string()
  .nonempty("bookingV3.sttManualReference.error.required")
  .min(3, "bookingV3.sttManualReference.error.minRefExt");

export const sttReferenceOptionalSchema = z
  .string()
  .refine(val => val === "" || val.length >= 3, {
    message: "bookingV3.sttManualReference.error.minRefExt",
  });
